import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  toggle() {
    this.buttonTarget.disabled = !this.inputTarget.value
  }
}
